var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12434_195029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5969 0.197098C15.85 0.384598 16 0.684598 16 1.00022V3.25022V11.5002C16 12.8815 14.6562 14.0002 13 14.0002C11.3438 14.0002 10 12.8815 10 11.5002C10 10.119 11.3438 9.00022 13 9.00022C13.35 9.00022 13.6875 9.05022 14 9.14397V4.59397L6 6.99397V13.5002C6 14.8815 4.65625 16.0002 3 16.0002C1.34375 16.0002 0 14.8815 0 13.5002C0 12.119 1.34375 11.0002 3 11.0002C3.35 11.0002 3.6875 11.0502 4 11.144V6.25022V4.00022C4 3.5596 4.29063 3.16897 4.7125 3.04085L14.7125 0.0408478C15.0156 -0.0497772 15.3438 0.0064728 15.5969 0.197098Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12434_195029"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.92d43c051836c013611c5feb4d9e7652.svg";
export { ForwardRef as ReactComponent };